// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"fe8941cc","221":"fc6f60bf","346":"c8b31a99","468":"16e0b1d6","614":"f665cd72","685":"c16ff9ef","813":"5a90deae","903":"8cd63622"}[chunkId] + ".chunk.css";
};